import { VueFireAuthWithDependencies, _VueFireAuthKey } from 'vuefire'
import { defineNuxtPlugin } from '#imports'
import { inject } from 'vue'
import {
  
    
      browserLocalPersistence,
    
  

  
    browserPopupRedirectResolver,
  

  
    prodErrorMap,
  
} from 'firebase/auth'

/**
 * Setups VueFireAuth for the client. This version creates some listeners that shouldn't be set on server.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const firebaseApp = nuxtApp.$firebaseApp

  VueFireAuthWithDependencies({
    initialUser: nuxtApp.payload.vuefireUser,
    dependencies: {
      
        errorMap: prodErrorMap,
      

      
        persistence: [
        
          browserLocalPersistence,
        
        ],
      

      
        popupRedirectResolver: browserPopupRedirectResolver,
      
    },
  })(firebaseApp, nuxtApp.vueApp)

  return {
    provide: {
      firebaseAuth: nuxtApp.vueApp.runWithContext(() => inject(_VueFireAuthKey))
    },
  }
})
